<template>
  <div class="homebox">
    <el-container style="height: 100%" direction="vertical">
      <el-header class="elheader" height="65px">
        <div class="left">
          <div style="padding: 0 5px 0 0">
            <i class="el-icon-document-copy" style="font-size: 50px; color: white"></i>
          </div>
          <div style="padding-top: 5px">
            <div style="font-weight: bold">{{SYS.systitle}}</div>
            <div>{{SYS.subtitle}}</div>
          </div>
        </div>
        <div class="right" style="">
          <div v-if="CU.cu.spid=='0'">当前院校：{{currentuser.sname}}</div>
          <div v-else><span>当前院校：</span>{{currentuser.spname}}<i class="el-icon-arrow-right">{{currentuser.sname}}</i>
          </div>
          <div>
            <span>当前用户：</span><span style="color:red;">{{currentuser.uname}}</span><span>[{{currentuser.uclass}}]</span>
            <el-button type="text" size="small" @click="changepwd()">修改信息</el-button>
            <el-button type="text" size="small" @click="relogin()">系统退出</el-button>
          </div>
        </div>
      </el-header>      
      <el-container style="overflow:auto;padding:1px;">
        <el-aside class="elaside" :width="asidewidth+'px'">
          <el-menu background-color="#fbfbfb" style="width:100%;" text-color="#000" active-text-color="red"
            :default-active="$router.currentRoute.path" router class="el-menu-vertical" :collapse="isCollapse"
            unique-opened>
            <el-submenu index="1" v-if="CU.cu.uclass == '管理员'">
              <template slot="title">
                <i class="el-icon-s-platform"></i>
                <span slot="title">系统管理</span>
              </template>
              <el-menu-item-group v-if="CU.cu.spid == '0'">
                  <span slot="title">基础数据</span>
                <el-menu-item index="/main/school">
                  <i class="el-icon-school"></i>
                  <span slot="title">分院/系部管理</span>
                </el-menu-item>
                <el-menu-item index="/main/user">
                  <i class="el-icon-user"></i>
                  <span slot="title">用户管理</span>
                </el-menu-item>
                <el-menu-item index="/main/enterprise">
                  <i class="el-icon-school"></i>
                  <span slot="title">企业管理</span>
                </el-menu-item>
                <el-menu-item index="/main/major">
                  <i class="el-icon-school"></i>
                  <span slot="title">专业代码</span>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <span slot="title">教务数据</span>
                <el-menu-item index="/main/teacher">
                  <i class="el-icon-s-custom"></i>
                  <span slot="title">指导老师管理</span>
                </el-menu-item>
                <el-menu-item index="/main/classes">
                  <i class="el-icon-copy-document"></i>
                  <span slot="title">班级管理</span>
                </el-menu-item>
                <el-menu-item index="/main/students">
                  <i class="el-icon-user-solid"></i>
                  <span slot="title">学生管理</span>
                </el-menu-item>
                <el-menu-item index="/main/titlepublic">
                  <i class="el-icon-s-opportunity"></i>
                  <span slot="title">选题管理</span>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group v-if="CU.cu.spid == '0'">
                <span slot="title">任务设置</span>
                <el-menu-item index="/main/fileclass">
                  <i class="el-icon-date"></i>
                  <span slot="title">任务时间管理</span>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group v-if="CU.cu.spid == '0'">
                <span slot="title">系统日志</span>
                <el-menu-item index="/main/log">
                  <i class="el-icon-date"></i>
                  <span slot="title">操作日志</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">
                <div>
                  <i class="el-icon-menu"></i>
                  <span slot="title">任务管理</span>
                </div>
              </template>
              <el-menu-item index="/main/title" v-if="CU.cu.uclass != '管理员' && CU.cu.uclass != '专家'">
                  <i class="el-icon-edit"></i>
                  <span slot="title">选题申报</span>
              </el-menu-item>
              <el-menu-item index="/main/titleselect" v-if="CU.cu.uclass == '学生'">
                  <i class="el-icon-finished"></i>
                  <span slot="title">学生选题</span>
              </el-menu-item>
              <el-menu-item-group v-for="(item, index) in optionstask" :key="index" :index="item.TID">
                <span slot="title">{{ item.TNAME }}</span>
                <el-menu-item :index="citem.SMPATH + '/' + SetSFT(citem)" v-for="citem in item.children" :key="citem.TID">
                  <i :class="citem.SMICON"></i>
                  <span slot="title">{{ citem.TNAME }}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-s-opportunity"></i>
                <span slot="title">统计分析</span>
              </template>
              <el-menu-item-group v-if="CU.cu.uclass != '学生'">
                <span slot="title">任务分析</span>
                <el-menu-item index="/main/reportfinish">
                  <i class="el-icon-data-analysis"></i>
                  <span slot="title">任务完成情况</span>
                </el-menu-item>
                <el-menu-item index="/main/fileready" style="border-bottom:1px solid #f0f0f0;">
                  <i class="el-icon-search"></i>
                  <span slot="title">任务数据统计</span>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group v-if="CU.cu.cc == '1'">
                <span slot="title">查重报告</span>
                <el-menu-item index="/main/reportcc" v-if="CU.cu.uclass != '学生'">
                  <i class="el-icon-message-solid"></i>
                  <span slot="title">查重报告分析</span>
                </el-menu-item>
                <el-menu-item index="/main/reportcclist">
                  <i class="el-icon-date"></i>
                  <span slot="title">查重检测记录</span>
                </el-menu-item>
              </el-menu-item-group>

            </el-submenu>
            <el-submenu index="4" v-if="CU.cu.uclass == '管理员' && CU.cu.spid == '0' && CU.cu.sjk == '1'">
              <template slot="title">
                <div>
                  <i class="el-icon-s-promotion"></i>
                  <span slot="title">数据上传</span>
                </div>
              </template>
              <el-menu-item-group v-if="CU.cu.uclass != '学生'">
                <span slot="title">上传到省平台</span>
                <el-menu-item index="/main/shengget">
                  <i class="el-icon-document-copy"></i>
                  <span slot="title">获取省厅学生名单</span>
                </el-menu-item>
                <el-menu-item index="/main/shengchk">
                  <i class="el-icon-folder-checked"></i>
                  <span slot="title">校验学生名单</span>
                </el-menu-item>
                <el-menu-item index="/main/designupload">
                  <i class="el-icon-upload2"></i>
                  <span slot="title">成果上传省厅</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
             <el-menu-item style="border-top: 1px solid #ddd;">
              <a href="/enterprisedata.html" target="_blank">
                <i class="el-icon-s-data"></i>
                <span>企业数据统计分析</span></a>
            </el-menu-item>
            <el-menu-item style="border-top: 1px solid #ddd;">
              <a href="/help/help.html" target="_blank">
                <i class="el-icon-question"></i>
                <span>操作在线教程</span></a>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-container>
          <!-- <div class="toppath">当前位置：{{$router.currentRoute.name}}</div> -->
          <el-header height="35px"
            style="background-color: #fbfbfb;padding:10px;box-shadow: 3px 3px 3px #ccc;border-left:1px solid #ccc">

            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>
                <i style="color:#666;cursor:pointer;font-size:18px;" v-if="isCollapse" class="el-icon-s-unfold"
                  @click="collapse()"></i>
                <i style="color:#666;cursor:pointer;font-size:18px;" v-else class="el-icon-s-fold"
                  @click="collapse()"></i>
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/main' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item
                :to="{ path: $router.currentRoute.path }">{{$router.currentRoute.name}}</el-breadcrumb-item>
            </el-breadcrumb>
          </el-header>
          <el-main>
            <router-view></router-view>
          </el-main>
          <copyright></copyright>
        </el-container>
      </el-container>
    </el-container>
    <el-dialog title="修改基本信息" :visible="dialogFormVisible" :show-close="false">
      <el-form label-width="80px">
        <el-form-item label="用户名称">
          <el-input placeholder="请输入用户名称" v-model="userdata.UNAME" readonly></el-input>
        </el-form-item>
        <el-form-item label="用户类型">
          <el-input v-model="userdata.UCLASS" readonly></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="userdata.TEL" @input="inputmethod()"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱">
          <el-input v-model="userdata.EMAIL" @input="inputmethod()"></el-input>
        </el-form-item>
        <el-form-item label="旧密码">
          <el-input placeholder="请输入用户的旧密码" type="password" @input="inputmethod()" v-model="userdata.OLDPWD"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input placeholder="请输入用户的新密码" type="password" @input="inputmethod()" v-model="userdata.NEWPWD"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input placeholder="请再次确认用户新密码" type="password" @input="inputmethod()"
            v-model="userdata.NEWPWD1"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="postpwd()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import copyright from "@/components/copyright";
export default {
  components:{
    copyright
  },
  data() {
    return {
      asidewidth: 200,
      pathname: "",
      isCollapse: false,
      currentuser: {},
      loading: false,
      optionstask: [],
      YY: 2020,
      dialogFormVisible:false,
      userdata:{
        SID:'',
        UID:'',
        UNAME:'',
        UCLASS:'',
        OLDPWD:'',
        NEWPWD:'',
        NEWPWD1:''
      },
      timer:'',
    };
  },
  mounted() {
    this.timer = setInterval(this.gettoken, 240000);
  },
  beforeDestroy() {
      clearInterval(this.timer);
  },
  created() {
    let that = this
    this.currentuser = this.CU.cu;
    if (!this.CU.token)
      this.$router.replace('/')
    that.getyears(function (res) {
      if (res.length > 0) {
        that.YY = res[0];
        that.gettasks()
      }
    });
  },
  methods: {
    gettoken(){
      const that = this;
      this.RefreshToken(
        function (res) {
          //console.log(res)
        },
        function (err) {
          console.log(err)
        }
      );
    },
    inputmethod() {
      this.$forceUpdate()
    },
    changepwd(){
      this.userdata.SID = this.CU.cu.sid
      this.userdata.UID = this.CU.cu.uid
      this.userdata.UNAME = this.CU.cu.uname
      this.userdata.UCLASS = this.CU.cu.uclass
      this.userdata.OLDPWD = ""
      this.userdata.NEWPWD = ""
      this.userdata.NEWPWD1 = ""
      this.dialogFormVisible = true
      this.userdata.TEL = this.CU.cu.tel
      this.userdata.EMAIL = this.CU.cu.email
    },
    postpwd(){
      let that = this
      let errorflag=false
      let errormes=""
      if(!this.userdata.NEWPWD){
        errorflag = true
        errormes = '密码不能为空！'
      }
      if(this.userdata.NEWPWD !=this.userdata.NEWPWD1){
        errorflag = true
        errormes = '两次输入的新密码不一致！'
      }
      if(this.checkStrong(this.userdata.NEWPWD)<this.SYS.pawmin){
        this.$message({
          message: '密码不够强！请加强密码的复杂度。',
          type: 'warning'
        });
        return false;
      }
      if(errorflag){
        this.$alert(errormes,'导入失败!',{
          confirmButtonText:'确定',
          type: 'warning',
          callback: action => {}
        });
        return;
      }
      that.PostData('EDITPWD',that.userdata,function(res){
        if (res.data.error_code == 0) {
          that.dialogFormVisible = false;
          let curcu = that.CU;
          // curcu.pwd = that.userdata.NEWPWD
          curcu.cu.tel = that.userdata.TEL
          curcu.cu.email = that.userdata.EMAIL
          that.setItem("currentuser", curcu)
        }
        else{
          that.$alert(res.data.message,'操作失败!',{
            confirmButtonText:'确定',
            type: 'warning',
            callback: action => {}
          });
        }
      },function(err){
          that.$alert(err,'操作失败',{
            confirmButtonText:'确定',
            type: 'warning',
            callback: action => {}
          });
      })
      

      
    },
    gettasks() {
      const that = this;
      that.loading = true;
      let pars = {
        SID: that.CU.cu.sid,
        YY: that.YY,
        TRANGE: ""
      };
      if (that.CU.cu.uclass == '管理员') {
        if (that.CU.cu.spid == "0")
          pars.TRANGE = "院校"
        else
          pars.TRANGE = "分院/系部"
      } else
        pars.TRANGE = that.CU.cu.uclass;
      that.PostData(
        "Common/GetOtherMethod", {
          methodname: "GetTasksTree",
          pars: pars,
        },
        function (res) {
          that.optionstask = res.data.data;
          that.loading = false;
        },
        function (err) {
          console.log(err)
          that.loading = false;
        }
      );
    },
    selectmenuitem(smi) {
      let that = this
      if (that.$router.currentRoute.path == smi)
        return
      that.$router.replace({
        path: smi
      })
    },
    relogin() {
      const that = this
      let curcu = that.CU;
      curcu.pwd = ""
      curcu.token = ""
      that.setItem("currentuser", curcu)
      that.$router.replace("/");
    },
    collapse() {
      if (this.isCollapse) {
        this.asidewidth = 200
        this.isCollapse = false;
      } else {
        this.asidewidth = 66
        this.isCollapse = true;
      }
    },
  },
};
</script>

<style lang="less">
// /* 设置滚动条的样式 */
// ::-webkit-scrollbar {
//   width: 5px;
//   height: 5px;
// }

// /* 滚动槽 */
// ::-webkit-scrollbar-track {
//   border-radius: 10px;
// }

// ::-webkit-scrollbar-corner {
//   background-color: #0062ab;
// }

// /* 滚动条滑块 */
// ::-webkit-scrollbar-thumb {
//   border-radius: 10px;
//   background: #ccc;
// }

html,
body,
#app,
.homebox,
.el-container {
  padding: 0px;
  margin: 0px;
  height: 100%;
}

.el-main {
  padding: 10px;
  border: 1px solid #ccc;
}

.el-footer {
  background-color: #fbfbfb;
  color: #ccc;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  line-height: 30px;
}

.elaside {
  background-color: #fbfbfb;
  color: #333;
  border: 0px solid #ccc;
  box-shadow: 3px 0px 3px #ccc;
}

.elheader {
  background-color: #0062ab;
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  text-align: left;
  padding: 10px 10px;
  color: white;

  .left {
    display: flex;
    flex-direction: row
  }

  .right {
    padding-top: 5px;
    display: flex;
    flex-direction: column;
    color: white;
    font-size: 12px;

    span {
      padding-right: 5px;
    }
  }
}

.el-menu {
  border-right: 0px solid #ccc;
  border-bottom-color: #999;
}

.el-menu-item i {
  
  color: #222;
}

.el-submenu__title {
  border-top: 1px solid #ddd;
  color: #222;
}

.el-submenu__title i {
  color: #222;
}

.el-menu-vertical {
  text-align: left;
}

.el-menu-item-group__title {
  font-size: 14px;
  color: #666;
  font-style: italic;
}
.el-submenu.is-active .el-submenu__title {
  border-bottom: 1px solid #b18d8d;
  background-color: #0062ab;
  color: white;
}

.el-card__body {
  padding: 3px;
}

.el-dialog {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.el-dialog__header {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px 20px;
  text-align: left;
  border-bottom: 1px solid #ccc;
  background-color: #eee;
  font-weight: bold;
}

.el-table--mini td,
.el-table--mini th {
  padding: 3px 0;
}
</style>
